import React from 'react';
import EmployeeDataArea from '../EmployeeDataArea/EmployeeDataArea';

function Container () {
    return (
      <>
        <EmployeeDataArea />
      </>
    );
  };

export default Container;
